var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.179 44.9998C10.9713 34.9267 10.7637 26.6851 10.7637 15.1875H52.6034C52.9149 15.1875 53.1225 15.391 53.1225 15.5945C53.2265 18.8227 53.2726 23.0761 53.2879 27.0259",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40485 46.2197C7.0996 34.9256 7.09961 27.9049 7.09961 14.0671C7.09961 12.7444 8.01535 11.5234 9.13458 11.5234L55.0755 11.5234C55.9912 11.6252 56.8052 12.4392 56.907 13.3549C57.2155 19.7825 57.2641 23.3022 57.2368 28.5022",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0803 45.5078H7.50781",
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9751 46.2357C60.8103 46.2302 60.649 46.2246 61.5117 46.2188V48.9826C61.5117 50.3941 60.3769 51.5434 58.9655 51.5604V51.5604M36.9209 46.3133C23.0636 46.3694 19.4617 46.3447 2.54492 46.2188V48.5655C2.54492 50.208 3.86686 51.5452 5.50928 51.5654C19.8661 51.7417 23.8497 51.789 36.9209 51.6989",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5996 45.5078H37.1287V47.8747H26.5996V45.5078Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6524 34.6144C45.7125 33.1314 46.655 32.3516 47.8916 32.3516H57.2061C58.4427 32.3516 59.3805 33.437 59.5699 34.949C59.7593 36.461 59.5699 54.3564 59.5699 54.3564C59.5699 55.811 58.3388 56.6976 57.013 56.8381C55.6872 56.9785 49.8159 56.9402 47.8916 56.8381C46.5384 56.7662 45.6524 55.2811 45.6524 54.0314C45.4619 46.3039 45.5923 36.0974 45.6524 34.6144Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1572 37.5937C60.2042 38.1717 60.2014 38.4674 60.1572 38.9647",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1282 41.2422C60.1562 41.8587 60.1406 42.1939 60.1049 42.7871",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1726 41.9063C45.1408 40.3468 45.1585 39.4989 45.1992 37.9983",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8613 32.5473C54.5432 32.5661 54.3795 33.7856 53.9318 33.7856C53.4545 33.8943 51.9829 33.8944 51.4872 33.7856C51.0229 33.7856 50.8431 32.5718 50.5319 32.5473",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1016 33.0625H54.2902",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9316 53.8438C52.2581 53.9306 52.993 53.9387 54.2934 53.9162",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0273 32.0822C58.0079 31.0816 57.979 30.6425 57.9378 30.3735C57.6609 28.5644 56.2899 27.2656 54.4817 27.2656H40.8631C39.0549 27.2656 37.677 28.1987 37.5891 29.9731C37.5012 31.7476 37.3105 43.96 37.5891 53.2062C37.5891 54.7015 38.8845 56.4785 40.8631 56.5644C43.2302 56.6673 42.8908 56.5644 46.3666 56.6288",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8792 37.25C36.8482 35.988 36.8655 35.3018 36.9051 34.0874",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0527 27.4979C50.5875 27.5206 50.3482 28.9951 49.6937 28.9951C48.9958 29.1266 46.8441 29.1266 46.1194 28.9951C45.4405 28.9951 45.1777 27.5274 44.7227 27.4979",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5566 28.125H50.2187",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3926 46.9062V49.894",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleDevices);
export default __webpack_public_path__ + "static/media/multiple-devices.98558e01c96aa0a5ead7fb8bcf1932d9.svg";
export { ForwardRef as ReactComponent };